<template>
  <div class="container-fluid py-4">
    <h2 class="text-2xl font-bold mb-4">
      <i class="bx bx-clipboard"></i> Historial de Comandas
    </h2>

    <!-- Filtros -->
    <div class="card shadow-sm mb-4">
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label">Fecha Inicio</label>
            <input
              type="date"
              v-model="filtros.fechaInicio"
              class="form-control"
            />
          </div>
          <div class="col-md-2">
            <label class="form-label">Hora Inicio</label>
            <input
              type="time"
              v-model="filtros.horaInicio"
              class="form-control"
            />
          </div>
          <div class="col-md-3">
            <label class="form-label">Fecha Fin</label>
            <input
              type="date"
              v-model="filtros.fechaFin"
              class="form-control"
            />
          </div>
          <div class="col-md-2">
            <label class="form-label">Hora Fin</label>
            <input type="time" v-model="filtros.horaFin" class="form-control" />
          </div>
          <div class="col-md-2">
            <label class="form-label">Ordenar por</label>
            <select v-model="filtros.ordenar" class="form-select">
              <option value="fecha_desc">Fecha (más reciente)</option>
              <option value="fecha_asc">Fecha (más antigua)</option>
              <option value="subtotal_desc">Subtotal (mayor)</option>
              <option value="subtotal_asc">Subtotal (menor)</option>
              <option value="mesa_asc">Mesa (A-Z)</option>
            </select>
          </div>
          <div class="col-md-2 d-flex align-items-end">
            <button @click="cargarHistorial" class="btn btn-primary me-2">
              <i class="bx bx-search"></i> Buscar
            </button>
            <button @click="limpiarFiltros" class="btn btn-secondary me-2">
              <i class="bx bx-x"></i> Limpiar
            </button>
            <button
              @click="generarPDF"
              class="btn btn-outline-danger"
              :disabled="generandoPDF"
            >
              <i class="bx bx-file-pdf"></i>
              {{ generandoPDF ? "Generando..." : "Generar PDF" }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="loading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
    </div>

    <!-- Tabla de historial -->
    <div v-else class="card shadow-sm">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-hover">
            <thead class="table-light">
              <tr>
                <th>Pedido #</th>
                <th>Correlativo</th>
                <th>Mesa / Habitación</th>
                <th>Estado</th>
                <th>Pago</th>
                <th>Mesero</th>
                <th>Fecha Pedido</th>
                <th>Items</th>
                <th class="text-end">Subtotal</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="historial.length === 0">
                <td colspan="10" class="text-center text-muted py-4">
                  No hay comandas registradas con los filtros seleccionados
                </td>
              </tr>
              <tr v-for="item in historialOrdenado" :key="item.pedido_id">
                <td>
                  <span class="badge bg-primary"
                    >Pedido #{{ item.pedido_id }}</span
                  >
                </td>
                <td>
                  <span class="badge bg-secondary">{{
                    item.correlativo || "Sin imprimir"
                  }}</span>
                </td>
                <td>
                  <div v-if="item.cargado_habitacion">
                    <span class="badge bg-info text-dark me-1"
                      >🏨 Hab. {{ item.habitacion }}</span
                    >
                    <div class="small text-muted mt-1">{{ item.cliente }}</div>
                    <div class="small">
                      <span class="badge bg-light text-dark border">{{
                        item.numero_reserva
                      }}</span>
                    </div>
                  </div>
                  <div v-else>
                    <strong>Mesa {{ item.mesa || "N/A" }}</strong>
                  </div>
                </td>
                <td>
                  <span
                    class="badge"
                    :class="
                      item.estado == 0 ? 'bg-warning text-dark' : 'bg-success'
                    "
                  >
                    {{ item.estado == 0 ? "Abierto" : "Cerrado" }}
                  </span>
                </td>
                <td>
                  <span v-if="item.pagada" class="badge bg-success"
                    >✔ Pagada</span
                  >
                  <span
                    v-else-if="item.cargada_habitacion"
                    class="badge bg-info text-dark"
                    >🏨 En habitación</span
                  >
                  <span
                    v-else-if="item.tiene_cuentas_pendientes"
                    class="badge bg-danger"
                    >✖ Pendiente</span
                  >
                  <span v-else class="badge bg-secondary">Sin cuentas</span>
                </td>
                <td>
                  <strong>{{ item.mesero }}</strong>
                </td>
                <td>{{ formatearFecha(item.fecha_creacion) }}</td>
                <td>
                  <span class="badge bg-secondary"
                    >{{ item.detalles.length }} items</span
                  >
                </td>
                <td class="text-end fw-bold">
                  Q{{ Number(item.subtotal || 0).toFixed(2) }}
                </td>
                <td>
                  <button
                    @click="verDetalles(item)"
                    class="btn btn-sm btn-primary me-1"
                    title="Ver detalles"
                  >
                    <i class="bx bx-show"></i>
                  </button>
                  <button
                    @click="reimprimirComanda(item)"
                    class="btn btn-sm btn-success me-1"
                    title="Reimprimir comanda"
                  >
                    <i class="bx bx-printer"></i>
                  </button>
                  <button
                    v-if="
                      item.tiene_cuentas_pendientes &&
                      item.cargado_habitacion &&
                      item.id_reserva_habitacion
                    "
                    @click="
                      $router.push(
                        '/pagar-por-habitacion/' + item.id_reserva_habitacion,
                      )
                    "
                    class="btn btn-sm btn-info me-1"
                    title="Ir a pagar (habitación)"
                  >
                    <i class="bx bx-credit-card"></i>
                  </button>
                  <button
                    v-else-if="
                      item.tiene_cuentas_pendientes &&
                      !item.cargado_habitacion &&
                      item.id_cuenta_pendiente
                    "
                    @click="
                      $router.push(
                        '/pagar-cuenta-pedido/' + item.id_cuenta_pendiente,
                      )
                    "
                    class="btn btn-sm btn-warning me-1"
                    title="Ir a pagar"
                  >
                    <i class="bx bx-credit-card"></i>
                  </button>
                  <button
                    v-if="esAdmin"
                    @click="abrirEditar(item)"
                    class="btn btn-sm btn-warning me-1"
                    :disabled="item.pagada || item.cargada_habitacion"
                    :title="item.pagada || item.cargada_habitacion ? 'No editable: comanda con pago' : 'Editar comanda'"
                  >
                    <i class="bx bx-edit"></i>
                  </button>
                  <button
                    v-if="esAdmin"
                    @click="confirmarEliminar(item)"
                    class="btn btn-sm btn-danger"
                    :disabled="item.pagada || item.cargada_habitacion"
                    :title="item.pagada || item.cargada_habitacion ? 'No eliminable: comanda con pago' : 'Eliminar comanda'"
                  >
                    <i class="bx bx-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginación (implementar si es necesario) -->
        <div class="mt-3 text-muted small d-flex justify-content-between">
          <span>Mostrando {{ historial.length }} comandas</span>
          <span v-if="historial.length > 0">
            Total general:
            <strong>Q{{ totalGeneral.toFixed(2) }}</strong> &nbsp;|&nbsp;
            Cargadas a habitación:
            <strong>{{ totalCargadasHabitacion }}</strong>
          </span>
        </div>
      </div>
    </div>

    <!-- Modal de confirmación para eliminar -->
    <div
      v-if="mostrarModalEliminar"
      class="modal fade show d-block"
      tabindex="-1"
      style="background: rgba(0, 0, 0, 0.5)"
      @click.self="cerrarModalEliminar"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Confirmar Eliminación</h5>
            <button
              type="button"
              class="btn-close"
              @click="cerrarModalEliminar"
            ></button>
          </div>
          <div class="modal-body">
            <div class="alert alert-danger mb-3">
              Esta acción es permanente. Se eliminarán el pedido, todos sus items y cuentas.
            </div>
            <strong>Pedido:</strong> #{{ itemAEliminar?.pedido_id }}<br />
            <strong>Mesa:</strong> {{ itemAEliminar?.mesa || 'N/A' }}
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="cerrarModalEliminar"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-danger"
              @click="eliminarComanda"
            >
              Eliminar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de edición de comanda -->
    <div
      v-if="mostrarModalEditar"
      class="modal fade show d-block"
      tabindex="-1"
      style="background: rgba(0, 0, 0, 0.5)"
      @click.self="cerrarModalEditar"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="bx bx-edit"></i> Editar Comanda #{{ itemAEditar?.pedido_id }}
            </h5>
            <button type="button" class="btn-close" @click="cerrarModalEditar"></button>
          </div>
          <div class="modal-body">
            <div v-if="errorEdicion" class="alert alert-danger">{{ errorEdicion }}</div>
            <p class="text-muted small mb-3">
              Solo puedes reducir cantidades. Los ítems con cantidad 0 se cancelan completamente.
            </p>
            <table class="table table-sm">
              <thead class="table-light">
                <tr>
                  <th>Item</th>
                  <th class="text-center" style="width:120px">Cantidad actual</th>
                  <th class="text-center" style="width:140px">Nueva cantidad</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in itemsEditar" :key="item.id_detalle_pedido">
                  <td>{{ item.nombre }}</td>
                  <td class="text-center">{{ item.cantidad_original }}</td>
                  <td class="text-center">
                    <input
                      type="number"
                      v-model.number="itemsEditar[idx].nueva_cantidad"
                      :min="0"
                      :max="item.cantidad_original"
                      class="form-control form-control-sm text-center"
                      style="width:80px;display:inline-block"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="cerrarModalEditar">Cancelar</button>
            <button
              type="button"
              class="btn btn-primary"
              @click="guardarEdicion"
              :disabled="guardandoEdicion"
            >
              <span v-if="guardandoEdicion" class="spinner-border spinner-border-sm me-1"></span>
              Guardar cambios
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de detalles de comanda -->
    <div
      v-if="mostrarModalDetalles"
      class="modal fade show d-block"
      tabindex="-1"
      style="background: rgba(0, 0, 0, 0.5)"
      @click.self="cerrarModalDetalles"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="bx bx-clipboard"></i> Detalles del Pedido #{{
                itemSeleccionado?.pedido_id
              }}
            </h5>
            <button
              type="button"
              class="btn-close"
              @click="cerrarModalDetalles"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row mb-3">
              <div class="col-md-6">
                <p>
                  <strong>Pedido:</strong> #{{ itemSeleccionado?.pedido_id }}
                </p>
                <p v-if="itemSeleccionado?.cargado_habitacion">
                  <strong>🏨 Habitación:</strong>
                  {{ itemSeleccionado?.habitacion }}
                </p>
                <p v-else>
                  <strong>Mesa:</strong> {{ itemSeleccionado?.mesa }}
                </p>
                <p>
                  <strong>Estado:</strong>
                  <span
                    class="badge ms-2"
                    :class="
                      itemSeleccionado?.estado == 0
                        ? 'bg-warning text-dark'
                        : 'bg-success'
                    "
                  >
                    {{ itemSeleccionado?.estado == 0 ? "Abierto" : "Cerrado" }}
                  </span>
                </p>
                <p>
                  <strong>Pago:</strong>
                  <span
                    v-if="itemSeleccionado?.pagada"
                    class="badge ms-2 bg-success"
                    >✔ Pagada</span
                  >
                  <span
                    v-else-if="itemSeleccionado?.cargada_habitacion"
                    class="badge ms-2 bg-info text-dark"
                    >🏨 Cargada a habitación (pendiente checkout)</span
                  >
                  <span
                    v-else-if="itemSeleccionado?.tiene_cuentas_pendientes"
                    class="badge ms-2 bg-danger"
                    >✖ Pendiente de pago</span
                  >
                  <span v-else class="badge ms-2 bg-secondary"
                    >Sin cuentas</span
                  >
                </p>
              </div>
              <div class="col-md-6">
                <p><strong>Mesero:</strong> {{ itemSeleccionado?.mesero }}</p>
                <p>
                  <strong>Fecha:</strong>
                  {{ formatearFecha(itemSeleccionado?.fecha_creacion) }}
                </p>
                <p v-if="itemSeleccionado?.cargado_habitacion">
                  <strong>Reserva:</strong>
                  {{ itemSeleccionado?.numero_reserva }}
                </p>
                <p v-if="itemSeleccionado?.cliente">
                  <strong>Cliente:</strong> {{ itemSeleccionado?.cliente }}
                </p>
                <p>
                  <strong>Total Items:</strong>
                  {{ itemSeleccionado?.detalles?.length }}
                </p>
                <p>
                  <strong>Subtotal:</strong>
                  <span class="fw-bold"
                    >Q{{
                      Number(itemSeleccionado?.subtotal || 0).toFixed(2)
                    }}</span
                  >
                </p>
              </div>
            </div>

            <hr />

            <h6 class="mb-3">Items de la Comanda:</h6>
            <div
              v-if="itemSeleccionado?.detalles?.length === 0"
              class="alert alert-info"
            >
              No hay items registrados
            </div>
            <div v-else class="list-group">
              <div
                v-for="(detalle, index) in itemSeleccionado?.detalles"
                :key="index"
                class="list-group-item"
              >
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <h6 class="mb-1">
                      <span class="badge bg-primary me-2"
                        >{{ detalle.cantidad }}x</span
                      >
                      {{ detalle.nombre }}
                    </h6>

                    <!-- Opciones/Extras -->
                    <div
                      v-if="detalle.opciones && detalle.opciones.length > 0"
                      class="mt-2"
                    >
                      <small class="text-muted"><strong>Extras:</strong></small>
                      <div>
                        <span
                          v-for="(opcion, idx) in detalle.opciones"
                          :key="idx"
                          class="badge bg-info me-1"
                        >
                          +
                          {{
                            typeof opcion === "object" ? opcion.nombre : opcion
                          }}<span
                            v-if="
                              typeof opcion === 'object' &&
                              opcion.precio_extra > 0
                            "
                          >
                            (+Q{{
                              Number(opcion.precio_extra).toFixed(2)
                            }})</span
                          >
                        </span>
                      </div>
                    </div>

                    <!-- Ingredientes que no quiere -->
                    <div
                      v-if="
                        detalle.sin_ingredientes &&
                        detalle.sin_ingredientes.length > 0
                      "
                      class="mt-2"
                    >
                      <small class="text-muted"><strong>Sin:</strong></small>
                      <div>
                        <span
                          v-for="(ing, idx) in detalle.sin_ingredientes"
                          :key="idx"
                          class="badge bg-danger me-1"
                        >
                          Sin {{ ing }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-success me-auto"
              @click="reimprimirComanda(itemSeleccionado)"
            >
              <i class="bx bx-printer me-1"></i> Reimprimir
            </button>
            <button
              v-if="
                itemSeleccionado?.tiene_cuentas_pendientes &&
                itemSeleccionado?.cargado_habitacion &&
                itemSeleccionado?.id_reserva_habitacion
              "
              type="button"
              class="btn btn-info"
              @click="
                cerrarModalDetalles();
                $router.push(
                  '/pagar-por-habitacion/' +
                    itemSeleccionado.id_reserva_habitacion,
                );
              "
            >
              <i class="bx bx-credit-card me-1"></i> Ir a pagar (Hab.
              {{ itemSeleccionado?.habitacion }})
            </button>
            <button
              v-else-if="
                itemSeleccionado?.tiene_cuentas_pendientes &&
                !itemSeleccionado?.cargado_habitacion &&
                itemSeleccionado?.id_cuenta_pendiente
              "
              type="button"
              class="btn btn-warning"
              @click="
                cerrarModalDetalles();
                $router.push(
                  '/pagar-cuenta-pedido/' +
                    itemSeleccionado.id_cuenta_pendiente,
                );
              "
            >
              <i class="bx bx-credit-card me-1"></i> Ir a pagar
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              @click="cerrarModalDetalles"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config";
import { imprimirComandaCaja } from "@/utils/impresion";

export default {
  name: "HistorialComandas",
  data() {
    return {
      historial: [],
      loading: false,
      generandoPDF: false,
      filtros: {
        fechaInicio: "",
        horaInicio: "00:00",
        fechaFin: "",
        horaFin: "23:59",
        ordenar: "fecha_desc",
      },
      mostrarModalEliminar: false,
      itemAEliminar: null,
      mostrarModalDetalles: false,
      itemSeleccionado: null,
      mostrarModalEditar: false,
      itemAEditar: null,
      itemsEditar: [],
      guardandoEdicion: false,
      errorEdicion: null,
    };
  },
  computed: {
    esAdmin() {
      const rol = this.$store?.getters?.getUser?.IdRol;
      return rol === 1 || rol === 5;
    },
    historialOrdenado() {
      const arr = [...this.historial];
      switch (this.filtros.ordenar) {
        case "fecha_asc":
          return arr.sort(
            (a, b) => new Date(a.fecha_creacion) - new Date(b.fecha_creacion),
          );
        case "subtotal_desc":
          return arr.sort(
            (a, b) => Number(b.subtotal || 0) - Number(a.subtotal || 0),
          );
        case "subtotal_asc":
          return arr.sort(
            (a, b) => Number(a.subtotal || 0) - Number(b.subtotal || 0),
          );
        case "mesa_asc":
          return arr.sort((a, b) =>
            String(a.mesa || "").localeCompare(String(b.mesa || "")),
          );
        default:
          return arr.sort(
            (a, b) => new Date(b.fecha_creacion) - new Date(a.fecha_creacion),
          );
      }
    },
    totalGeneral() {
      return this.historial.reduce(
        (s, item) => s + Number(item.subtotal || 0),
        0,
      );
    },
    totalCargadasHabitacion() {
      return this.historial.filter((item) => item.cargado_habitacion).length;
    },
  },
  mounted() {
    this.inicializarFechas();
    this.cargarHistorial();
  },
  methods: {
    inicializarFechas() {
      const hoy = new Date();
      const hace7Dias = new Date(hoy);
      hace7Dias.setDate(hace7Dias.getDate() - 7);

      this.filtros.fechaInicio = hace7Dias.toISOString().split("T")[0];
      this.filtros.fechaFin = hoy.toISOString().split("T")[0];
    },
    async cargarHistorial() {
      this.loading = true;
      try {
        const params = {};
        if (this.filtros.fechaInicio)
          params.fecha_inicio =
            this.filtros.fechaInicio +
            " " +
            (this.filtros.horaInicio || "00:00") +
            ":00";
        if (this.filtros.fechaFin)
          params.fecha_fin =
            this.filtros.fechaFin +
            " " +
            (this.filtros.horaFin || "23:59") +
            ":59";

        const { data } = await axios.get(`${API_URL}/historial-comandas`, {
          params,
        });
        this.historial = data.historial || [];
      } catch (error) {
        console.error("Error cargando historial:", error);
      } finally {
        this.loading = false;
      }
    },
    limpiarFiltros() {
      this.filtros = {
        fechaInicio: "",
        horaInicio: "00:00",
        fechaFin: "",
        horaFin: "23:59",
        ordenar: "fecha_desc",
      };
      this.inicializarFechas();
      this.cargarHistorial();
    },
    formatearFecha(fecha) {
      if (!fecha) return "N/A";
      const date = new Date(fecha);
      return date.toLocaleString("es-GT", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    confirmarEliminar(item) {
      this.itemAEliminar = item;
      this.mostrarModalEliminar = true;
    },
    cerrarModalEliminar() {
      this.mostrarModalEliminar = false;
      this.itemAEliminar = null;
    },
    verDetalles(item) {
      this.itemSeleccionado = item;
      this.mostrarModalDetalles = true;
    },
    cerrarModalDetalles() {
      this.mostrarModalDetalles = false;
      this.itemSeleccionado = null;
    },
    reimprimirComanda(item) {
      if (!item) return;
      const pedido = { IdPedido: item.pedido_id };
      const detallesFormateados = (item.detalles || []).map((d) => ({
        nombre_platillo: d.nombre,
        cantidad: d.cantidad,
        precio_unitario: d.precio_unitario || 0,
        subtotal: d.subtotal || 0,
      }));
      const subtotal =
        item.subtotal ||
        detallesFormateados.reduce((s, d) => s + (d.subtotal || 0), 0);
      const cuenta = {
        Subtotal: subtotal,
        NombreCuenta: `Mesa ${item.mesa || "N/A"}`,
      };
      const mesa = { Numero: item.mesa };
      imprimirComandaCaja(
        pedido,
        cuenta,
        detallesFormateados,
        mesa,
        item.mesero,
        item.correlativo,
      );
    },
    async generarPDF() {
      this.generandoPDF = true;
      try {
        const params = { ordenar: this.filtros.ordenar };
        if (this.filtros.fechaInicio)
          params.fecha_inicio =
            this.filtros.fechaInicio +
            " " +
            (this.filtros.horaInicio || "00:00") +
            ":00";
        if (this.filtros.fechaFin)
          params.fecha_fin =
            this.filtros.fechaFin +
            " " +
            (this.filtros.horaFin || "23:59") +
            ":59";

        const response = await axios.get(`${API_URL}/historial-comandas/pdf`, {
          params,
          responseType: "blob",
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const fi = this.filtros.fechaInicio || "inicio";
        const ff = this.filtros.fechaFin || "fin";
        link.download = `historial-comandas-${fi}-${ff}.pdf`;
        link.click();
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error generando PDF:", error);
        alert("Error al generar el PDF.");
      } finally {
        this.generandoPDF = false;
      }
    },
    async eliminarComanda() {
      try {
        await axios.delete(
          `${API_URL}/historial-comandas/${this.itemAEliminar.pedido_id}`,
        );
        this.cerrarModalEliminar();
        this.cargarHistorial();
      } catch (error) {
        console.error("Error eliminando comanda:", error);
        alert(
          "Error al eliminar: " +
            (error.response?.data?.error || error.message),
        );
      }
    },
    abrirEditar(item) {
      this.itemAEditar = item;
      this.errorEdicion = null;
      this.itemsEditar = (item.detalles || [])
        .filter((d) => d.cantidad > 0)
        .map((d) => ({
          id_detalle_pedido: d.id_detalle_pedido,
          nombre: d.nombre,
          cantidad_original: d.cantidad,
          nueva_cantidad: d.cantidad,
        }));
      this.mostrarModalEditar = true;
    },
    cerrarModalEditar() {
      this.mostrarModalEditar = false;
      this.itemAEditar = null;
      this.itemsEditar = [];
      this.errorEdicion = null;
    },
    async guardarEdicion() {
      const cambios = this.itemsEditar.filter(
        (i) => i.nueva_cantidad < i.cantidad_original,
      );
      if (cambios.length === 0) {
        this.cerrarModalEditar();
        return;
      }
      this.guardandoEdicion = true;
      this.errorEdicion = null;
      try {
        await axios.put(
          `${API_URL}/historial-comandas/${this.itemAEditar.pedido_id}`,
          {
            items: this.itemsEditar.map((i) => ({
              id_detalle_pedido: i.id_detalle_pedido,
              nueva_cantidad: i.nueva_cantidad,
            })),
          },
        );
        this.cerrarModalEditar();
        this.cargarHistorial();
      } catch (error) {
        this.errorEdicion =
          error.response?.data?.error || "Error al guardar cambios";
      } finally {
        this.guardandoEdicion = false;
      }
    },
  },
};
</script>

<style scoped>
.table-responsive {
  max-height: 600px;
  overflow-y: auto;
}

.modal.show {
  display: block;
}
</style>
